import { AiFillHtml5 } from "react-icons/ai";
import { DiCss3 } from "react-icons/di";
import { RiBootstrapLine } from "react-icons/ri";
import { TbBrandJavascript } from "react-icons/tb";
import { BiLogoReact, BiLogoPython } from "react-icons/bi";
import { FaNode,FaRegFileWord } from "react-icons/fa";
import { BsGit } from "react-icons/bs";
import { SiMicrosoftexcel } from "react-icons/si";
import { SiMaterialformkdocs } from "react-icons/si";


import { SiExpress, SiMongodb, SiMongoose } from "react-icons/si";
export const techStackUtils = [
  { id: 1, name: "HTML", icon: AiFillHtml5,color:"#FD501A" },
  { id: 2, name: "CSS", icon: DiCss3 ,color:"#2D53E5"  },
  { id: 3, name: "Bootstrap", icon: RiBootstrapLine,color:"violet"  },
  { id: 4, name: "React-Bootstrap", icon: RiBootstrapLine ,color:"#712CF9"  },
  { id: 5, name: "Material UI", icon: SiMaterialformkdocs ,color:"#027BF7"  },
  { id: 6, name: "Javascript", icon: TbBrandJavascript,color:"yellow"  },
  { id: 7, name: "ReactJs", icon: BiLogoReact ,color:"lighblue"  },
  { id: 8, name: "Nodejs", icon: FaNode  ,color:"green" },
  { id:9, name: "ExpressJS", icon: SiExpress ,color:"black"  },
  { id:10, name: "MongoDB", icon: SiMongodb  ,color:"#5F993E" },
  { id: 11, name: "Mongoose", icon: SiMongoose  ,color:"orange" },
  { id: 12, name: "Word Plugin", icon: FaRegFileWord  ,color:"#47A8EE" },
  { id: 13, name: "Excel Custome plugin", icon: SiMicrosoftexcel  ,color:"green" },
  {
    id: 14,
    name: "Git",
    icon: BsGit,
  },
];
